export const protocols = [
  { value: "HTTP", label: "HTTPS" },
  { value: "SOCKS", label: "SOCKS5" }
];
